/**
 * Audit/beta kill-switch for the SPA billing overlay.
 *
 * Default ON (paywall hidden) so expired trials do not block the app.
 * Restore gates with `REACT_APP_DISABLE_PAYWALL=false` and a CRA rebuild
 * (Vercel frontend project — `REACT_APP_*` is baked at build time).
 */
export function isPaywallDisabled(): boolean {
  const raw = (process.env.REACT_APP_DISABLE_PAYWALL ?? 'true').trim().toLowerCase();
  return raw === 'true' || raw === '1';
}
